import {Routes} from '@angular/router';
import {LoginComponent} from './login/login.component';
import {EnableComponent as TwoFactorEnableComponent} from './two-factor/enable/enable.component';
import {ChallengeComponent as TwoFactorChallengeComponent} from './two-factor/challenge/challenge.component';
import {isLoggedInGuard} from '../guards/is-logged-in-guard';
import {hasTwoFactorAuthEnabledGuard} from '../guards/has-two-factor-auth-enabled-guard';
import {isNotLoggedInGuard} from '../guards/is-not-logged-in-guard';
import {hasTwoFactorAuthNotEnabledGuard} from '../guards/has-two-factor-auth-not-enabled-guard';
import {isNotAuthenticatedGuard} from '../guards/is-not-authenticated-guard';
import {HelpComponent} from './help/help.component';
import {ForgotComponent as ForgotPasswordComponent} from './password/forgot/forgot.component';
import {ResetComponent as ResetPasswordComponent} from './password/reset/reset.component';

export const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [isNotLoggedInGuard]
  },
  {
    path: 'two-factor',
    canActivate: [isLoggedInGuard, isNotAuthenticatedGuard],
    children: [
      {
        path: 'enable',
        component: TwoFactorEnableComponent,
        canActivate: [hasTwoFactorAuthNotEnabledGuard],
      },
      {
        path: 'challenge',
        component: TwoFactorChallengeComponent,
        canActivate: [hasTwoFactorAuthEnabledGuard],
      }
    ]
  },
  {
    path: 'help',
    component: HelpComponent,
    canActivate: [isNotAuthenticatedGuard]
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent,
    canActivate: [isNotAuthenticatedGuard]
  },
  {
    path: 'reset-password/:token',
    component: ResetPasswordComponent,
  },
  {
    path: '**',
    redirectTo: 'login',
  }
];
